import api from './http';

// Organizations
export const getOrganizations = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/organizations${queryString ? `?${queryString}` : ''}`);
};
export const getOrganization = (id) => api.get(`/organizations/${id}`);
export const getOrganizationMissions = (id) => api.get(`/organizations/${id}/missions`);
export const createOrganization = (data) => api.post('/organizations', data);
export const updateOrganization = (id, data) => api.patch(`/organizations/${id}`, data);
export const deleteOrganization = (id) => api.delete(`/organizations/${id}`);
export const importOrganizationsExcel = (fd) => api.post('/organizations/import-excel', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
export const downloadOrganizationsTemplate = () => api.get('/organizations/import-template', { responseType: 'blob' });
export const exportOrganizations = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/organizations/export${queryString ? `?${queryString}` : ''}`, { responseType: 'blob' });
};
